
<div class="layout-topbar">
    <div class="topbar-left">
        <a #menubutton tabindex="0" class="menu-button p-trigger" (click)="app.onMenuButtonClick($event)">
            <i class="pi pi-chevron-left"></i>
        </a>
        <!-- <img class="horizontal-logo" [routerLink]="['/']" [src]="'assets/layout/images/oncore_logo_white.svg'"/> -->
        <span class="topbar-separator"></span>
        <app-breadcrumb></app-breadcrumb>
        <!-- <img class="mobile-logo" [src]="'assets/layout/images/oncore_logo_white.svg'"/> -->
    </div>

    <div class="layout-topbar-menu-section">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-mask modal-in"></div>

    <div class="topbar-right">
        <ul class="topbar-menu">


            <li class="profile-item static sm:relative">
                <a tabindex="0" pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                    <i class="far fa-user profile-image"></i>
                    <span class="profile-name">{{loggedInUser}}</span>
                </a>
                <ul class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 right-0  z-5 top-auto">
                    <li>
                        <a (click)="logout()" pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Logga ut</span>
                            </span>
                        </a>
                    </li>
                </ul>
        </ul>
    </div>
</div>

